import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CursorClick01 = function CursorClick01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9 3.5V2M5.0607 5.0607 4 4m1.0607 9L4 14.0607m9-9L14.0607 4M3.5 9H2m13.8645 7.1896-2.4918 4.6274c-.2846.5287-.427.793-.5982.8599a.5.5 0 0 1-.4505-.0441c-.1551-.0988-.2434-.3857-.4202-.9595L8.4452 9.4453c-.1444-.4688-.2166-.7032-.1585-.8615a.5.5 0 0 1 .2971-.2971c.1583-.058.3927.0141.8614.1585l11.228 3.4586c.5738.1768.8607.2652.9595.4202a.5.5 0 0 1 .0441.4505c-.0668.1713-.3312.3136-.8598.5983l-4.6274 2.4917c-.0786.0423-.1179.0634-.1522.0906a.5.5 0 0 0-.0823.0823c-.0272.0343-.0483.0736-.0906.1522"
    })
  }));
};
export default CursorClick01;